import{withGlobalValue as o}from"./withGlobalValue.js";const t=o("cfa");export{t as useCSSPrefix};
//# sourceMappingURL=useCSSPrefix.js.map
